/**
 * Enum for Alarm Configuration Types
 * ANPR: Automatic Number Plate Recognition (Vehicle monitoring)
 * AHCR: Automatic Human Characteristics Recognition (People monitoring)
 */
export enum AlarmConfigurationType {
    ANPR = 0, // Vehicle alarms (License plates, vehicle colors)
    AHCR = 1, // People alarms (Gender, jacket colors, accessories)
}